import React, { Component } from 'react'
import './styles.scss'
import LanguageChanger from '../../Shared/LanguageChanger'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { adminUserActions } from '../../../redux/actions/admin/admin-user'

class Header extends Component {
  render () {
    const { t } = this.props
    return (
      <header className="mygiata_header_admin">
        <div className="mygiata_header_admin_top">
          <Link to="/admin" className="mygiata_admin_logo"/>
          <div style={{display:'flex',gap:'15px','justifyContent': 'end'}}>
            <nav className="mygiata_admin_top_navi">
              <ul className="mygiata_admin_top_navi_links">
                <li><Link to="/admin/sales/employees">{t('SALES_EMPLOYEES')}</Link></li>
                <li><Link to="/admin/orders">{t('ORDERS')}</Link></li>
                {this.props.loggedIn ? <li>
                  <span className={'Link'} onClick={this.props.logout}>{t('LOGOUT')}</span>
                </li> : null}
              </ul>
            </nav>
            <div style={{'width': '200px'}}>
              <LanguageChanger/>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: !!state.adminUser.loggedIn,
  }
}

const mapDispatchToProps = {
  logout: adminUserActions.logout
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Header))
